import styled, { css } from 'styled-components';
export const Title = styled.span `
  display: block;
  font-weight: 600;
  color: white;
`;
export const TagWrapper = styled.div `
  position: absolute;
  bottom: -1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  pointer-events: none;
  display: flex;
  justify-content: center;
`;
export const QuestionWrapper = styled.div `
  width: 100%;
  position: relative;
  
  ${({ hasTag }) => hasTag && css `margin-bottom: 1rem;`}
  
  input {
    display: none;

    & + label {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      border-radius: var(--border-radius-sm);

      background-color: var(--primary-darker);
      //background-color: var(--primary-btn);
      cursor: pointer;
      padding: 2.2rem;
      min-height: 8.4rem;
      transition: background-color 200ms linear;
      
      &:hover {
        background-color: var(--stepped-quiz-btn-hover);
      }
      
      #fitness-page & {
        border: 0.2rem solid white;
        background-color: var(--primary-dark, $primary-dark);
        
        &:hover {
          background-color: var(--primary-btn, $primary-btn);
          border-color: var(--primary-btn, $primary-btn);
        }
      }
    }
    
    &:checked + label {
      background-color: var(--stepped-quiz-btn-hover);
      
      #fitness-page & {
        background-color: var(--primary-btn, $primary-btn);
        border-color: var(--primary-btn, $primary-btn);
      }
    }
  }
`;
export const Wrapper = styled.div `
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  ${({ half }) => half && css `
    flex-flow: initial;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    //background-color: red;
    gap: 1.6rem;
    
    ${QuestionWrapper} {
      width: calc(50% - 0.8rem);
      //background-color: yellow;
    }
  `}
`;
export default {
    Wrapper,
    QuestionWrapper,
};
